// extracted by mini-css-extract-plugin
export default {"categoryView":"category-view_categoryView__hm5js","notEditable":"category-view_notEditable__tZHz5"};